import AuditZbhxrgs from './audit-zbhxrgs';
import Xgsq from './xgsq';
import AuditTzs from './audit-tzs';
import AuditZbgg from './audit-zbgg';
import AuditZbjggg from './audit-zbjggg';

import Back from './back'
import wtht from './wtht';

export default {
    path: 'business',
    component: () => import('@layout/empty'),
    children: [
        AuditZbhxrgs,
        Xgsq,
        AuditTzs,
        AuditZbgg,
        AuditZbjggg,
        Back,
        wtht
    ]
}
